import React from 'react';
import { VendorCollectionDesktop } from '@thd-olt-component-react/collection';
import { extend, QueryProvider } from '@thd-nucleus/data-sources';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { VendorCollectionsRedirector } from '@thd-nucleus/app-render';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { node } from 'prop-types';
import { Metadata, KitchenCabinetMetadata } from '@thd-olt-component-react/metadata';
import { useParams, useNavigate } from '@thd-olt-component-react/router';
import { RecentlyViewedWrapper } from '@thd-olt-component-react/thd-recs-containers';
import { SearchFeedback } from '@thd-olt-component-react/search-feedback';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useStore } from '@thd-nucleus/experience-context';

const ZoneCard = ({ children }) => {
  return <div className="zone-card">{children}</div>;
};

ZoneCard.propTypes = {
  children: node.isRequired
};

export const VendorCollections = () => {
  const store = useStore();

  const { collectionName } = useParams();
  const collectionItems = '';

  const navigate = useNavigate();
  const onChange = (data = {}) => {
    navigate(`/collection/kitchen-cabinets/${data.collectionIdValue}`, { disableScroll: true });
  };

  return (
    <>
      <VendorCollectionsRedirector collectionName={collectionName} />
      <Metadata>
        <KitchenCabinetMetadata collectionName={collectionName} />
      </Metadata>
      <Row className="isBound kitchen-cabinets">
        <ErrorBoundary name="collection">
          <VendorCollectionDesktop collectionName={collectionName} onChange={onChange} />
        </ErrorBoundary>
        <Col className="grey-bg">
          <ErrorBoundary name="search-feedback">
            <SearchFeedback type="collection" />
          </ErrorBoundary>
        </Col>
        <Col className="grey-bg">
          <QueryProvider
            cacheKey="rv-kitchenCabinet-recs"
            persist
          >
            <RecentlyViewedWrapper
              schemaName="rv_gm_pip_rr"
              errorBoundary
              hydrator={{
                className: 'grid',
                tag: ZoneCard,
                id: 'rv_gm_pip_rr'
              }}
            />
          </QueryProvider>
        </Col>
      </Row>
    </>
  );
};

VendorCollections.dataModel = extend(VendorCollectionDesktop, RecentlyViewedWrapper);
